import { useEffect } from "react";

import { AuthManagerEvents, EUserType, ListenerItem } from "@dreamcam/messenger-sdk";
import { useLoaderData } from "react-router";

import { onToast } from "@components/Toast";

import { useMessengerStore } from "@storage/global/useMessengerStore";
import { TSessionData } from "@storage/session/types";
import { msgTokenStorage } from "@storage/sessionStorage";

import { sdkMessenger } from "./messenger-sdk";

const chatManagerListeners: ListenerItem<AuthManagerEvents>[] = [];

export const useAuthMessenger = () => {
	const { currentAccount, app_token } = useLoaderData<TSessionData>();
	const { setCountUnreadMessages, setUserMsgData, isAuthMessenger, setIsAuthMessenger } = useMessengerStore();
	const messengerSdk = sdkMessenger();

	const handleAuthMessenger = async () => {
		if (isAuthMessenger) return;

		try {
			const { client_session_token } = await messengerSdk.authManager.loginAsync(
				app_token || "",
				EUserType.MODEL,
				currentAccount.chatClientId || "",
			);

			msgTokenStorage.setItem(client_session_token);

			setUserMsgData({
				chat_client_id: currentAccount.chatClientId || null,
				user_type: EUserType.MODEL,
			});
			setIsAuthMessenger(true);
		} catch (error) {
			const errorMessage = (error as Error).message;
			onToast({
				id: "msg-auth-error",
				message: "Error",
				description: errorMessage,
			});
		}
	};

	useEffect(() => {
		handleAuthMessenger();
	}, []);

	const subscribeSdkForEvents = () => {
		chatManagerListeners.push(
			messengerSdk.authManager.registerListener("onUpdateCountUnreadMessages", (args) => {
				setCountUnreadMessages(args.count);
			}),
		);
	};

	const unsubscribeAllEvents = () => {
		messengerSdk.authManager.unregisterListeners(chatManagerListeners);
	};

	useEffect(() => {
		subscribeSdkForEvents();

		return () => {
			unsubscribeAllEvents();
		};
	}, []);

	return null;
};
